// extracted by mini-css-extract-plugin
export default {"buttonArea":"FooterButtonArea_buttonArea__BxamO"};